/**
 * Mobile and in-app browsers block popups and partition storage.
 * Redirect sign-in works reliably when authDomain matches the app domain.
 */
export function prefersRedirectAuth() {
  const ua = navigator.userAgent || "";
  const isMobile = /iPhone|iPad|iPod|Android/i.test(ua);
  const isInAppBrowser = /FBAN|FBAV|Instagram|Twitter|Line\//i.test(ua);
  return isMobile || isInAppBrowser;
}
